import React, { Component, Fragment } from "react";
import image from "../../logo.png";
import "./VerifyNumber.css";
import { toEnglishNumber } from "../../classes/utils";
import withRouter from "../withRouter/withRouter";

class VerifyNumber extends Component {
    state = {
        mode: "login",
        code_sent: false,
        code_send_timeout: 120,
    };

    interval;
    connection;
    code;

    constructor(props) {
        super(props);
        this.refrencePage =
            props.router.params["*"] + props.router.location.search;
        this.mode = props.router.params.mode;
        this.timeoutInterval = this.timeoutInterval.bind(this);
    }
    componentDidMount() {
        this.mobile = localStorage.getItem("mobile");
        this.token = localStorage.getItem("token");
        if (
            (this.mode != "forgot" && (!this.mobile || !this.token)) ||
            (this.mode !== "verify" && this.mode != "forgot")
        ) {
            this.props.router.navigate("/");
        } else {
            this.connection = this.props.connection;
            this.connection.setCreds(this.mobile, this.token);
        }
    }

    timeoutInterval() {
        this.interval && clearInterval(this.interval);
        this.setState({ code_sent: true });
        this.interval = setInterval(() => {
            let { code_send_timeout } = this.state;
            code_send_timeout--;
            this.setState({
                code_send_timeout:
                    code_send_timeout > -1 ? code_send_timeout : 120,
            });
            code_send_timeout == 0 && clearInterval(this.interval);
        }, 1000);
    }

    render() {
        let { code_sent, code_send_timeout } = this.state;
        return (
            <div className='VerifyNumberComponent'>
                <div className='verify'>
                    {this.mode === "verify" && (
                        <div className='desc text info'>
                            <i className='ri-chat-check-line text warning'></i>
                            برای ادامه کار لطفا شماره موبایل خود را تایید کنید.
                        </div>
                    )}
                    <div>
                        {" "}
                        شماره همراه{this.mode === "verify" && this.mobile}
                        {this.mode === "forgot" && (
                            <input
                                type='tel'
                                onChange={(ev) => {
                                    this.mobile =
                                        ev.target.validity.valid &&
                                        ev.target.value;
                                }}
                                pattern='[0-9]{11}'
                                required
                            />
                        )}
                    </div>

                    <button
                        className='btn info'
                        onClick={(ev) => {
                            ev.preventDefault();
                            ev.stopPropagation();
                            this.connection
                                .request_verification_code(
                                    this.mode,
                                    this.mobile
                                )
                                .then((res) => {
                                    alert("کد ارسال شد");
                                    this.timeoutInterval();
                                })
                                .catch((err) => {
                                    if (err.response.data == "verified") {
                                        this.props.router.navigate(
                                            "/" + this.refrencePage
                                        );
                                    } else {
                                        alert(err.response.data);
                                    }
                                });
                        }}
                        disabled={code_sent && code_send_timeout > 1}
                    >
                        {(code_sent &&
                            code_send_timeout > 0 &&
                            `${code_send_timeout} ثانیه دیگر`) ||
                            "ارسال کد"}
                    </button>
                    {code_sent && (
                        <Fragment>
                            <input
                                type='text'
                                id='verification'
                                className='form-control'
                                pattern='[0]{1}[9]{1}[0-9]{9}'
                                placeholder='کد پیامک شده'
                                onChange={(ev) => {
                                    this.code = ev.target.value;
                                }}
                            />

                            <button
                                disabled={!code_sent}
                                className='btn confirm'
                                onClick={(ev) => {
                                    ev.preventDefault();
                                    ev.stopPropagation();

                                    this.connection
                                        .send_verification_code(this.mode, {
                                            code: this.code,
                                            mobile: this.mobile,
                                        })
                                        .then((res) => {
                                            this.mode == "forgot"
                                                ? this.props.router.navigate(
                                                      `/forgot/${this.mobile}/${this.code}`
                                                  )
                                                : this.props.router.navigate(
                                                      "/" + this.refrencePage
                                                  );
                                        })
                                        .catch((err) => {
                                            alert(err.response.data);
                                        });
                                }}
                            >
                                تایید
                            </button>
                        </Fragment>
                    )}
                    <a href='/'>
                        <button
                            className='btn danger'
                            onClick={(ev) => {
                                localStorage.removeItem("token");
                            }}
                        >
                            انصراف و خروج از حساب کاربری
                        </button>
                    </a>
                </div>
            </div>
        );
    }
}

export default withRouter(VerifyNumber);
